import useMultGame from '~/games/hooks/useMultGame'
import GameWrapper from '~/games/components/GameWrapper'
import useShowSubscriptionBanner from '~/hooks/useShowSubscriptionBanner'

function MultGameV2Page(): React.ReactElement {
  const { multGameURL } = useMultGame()
  const isSubscriptionBannerVisible = useShowSubscriptionBanner()

  return (
    <GameWrapper>
      <div className="w-screen h-screen">
        <iframe
          className={`w-full h-full absolute ${isSubscriptionBannerVisible ? 'top-16' : 'top-0'}`}
          id="multIframe"
          src={multGameURL}
        />
      </div>
    </GameWrapper>
  )
}

export default MultGameV2Page
